import { render, staticRenderFns } from "./MAM_brandList.vue?vue&type=template&id=fab9fdd0&scoped=true&"
import script from "./MAM_brandList.vue?vue&type=script&lang=js&"
export * from "./MAM_brandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab9fdd0",
  null
  
)

export default component.exports